var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-container',{staticClass:"p-4 bg-dark",attrs:{"fluid":""}},[_c('div',{attrs:{"align":"center"}},[_c('a',{attrs:{"href":"#/index"}},[_c('img',{attrs:{"src":"images/logout.png","alt":""}})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }